(function () {
  'use strict';

  if (window.__robosenHeaderInteractionsLoaded) {
    if (window.__robosenHeaderInit) window.__robosenHeaderInit(document);
    return;
  }
  window.__robosenHeaderInteractionsLoaded = true;

  var MOBILE_NAV_ID = 'rbn-primary-nav-mobile';
  var nav = null;
  var desktopRoot = null;
  var headerSectionEl = null;
  var mqlDesktop1150 = window.matchMedia('(min-width: 1150px)');
  var mqlReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var PILL_OP_MS = 250;
  var VIS_HIDE_DELAY_MS = 300;
  var PROMO_LEAF_MAX_PX = 450;
  var MOBILE_TIER3_AUTO_OPEN_MS = 500;

  var desktopDropdownGeomRaf = 0;
  var headerResizeRaf = 0;
  var pillOpacityCached = 0;
  var rbnPillHideGeomTimer = null;
  var hoveredDesktopLabel = null;
  var desktopOpenPanelId = null;
  var desktopCloseVisTimer = null;
  var desktopHoverLeaveTimer = null;
  var mobileMegaTier3Timer = null;
  var desktopGlobalEventsBound = false;

  function refreshHeaderRoots(scope) {
    var root = scope || document;
    nav = root.querySelector ? root.querySelector('#' + MOBILE_NAV_ID) : null;
    desktopRoot = root.querySelector ? root.querySelector('[data-rbn-desktop-nav]') : null;

    if (!nav) nav = document.getElementById(MOBILE_NAV_ID);
    if (!desktopRoot) desktopRoot = document.querySelector('[data-rbn-desktop-nav]');

    var headerRoot = desktopRoot || nav;
    headerSectionEl = headerRoot ? headerRoot.closest('[id^="shopify-section-"]') : null;
  }

  function isDesktopNav() {
    return mqlDesktop1150.matches;
  }

  function afterNextPaint(fn) {
    requestAnimationFrame(function () {
      requestAnimationFrame(fn);
    });
  }

  function setHeaderHeightVar() {
    if (!headerSectionEl) return;
    document.documentElement.style.setProperty('--header-height', Math.round(headerSectionEl.clientHeight) + 'px');
  }

  function cancelRbnPillHideGeom() {
    if (!rbnPillHideGeomTimer) return;
    clearTimeout(rbnPillHideGeomTimer);
    rbnPillHideGeomTimer = null;
  }

  function getDesktopBar() {
    return desktopRoot ? desktopRoot.querySelector('[data-rbn-desktop-bar]') : null;
  }

  function resetDesktopPillGeometry() {
    var bar = getDesktopBar();
    if (!bar) return;
    cancelRbnPillHideGeom();
    bar.style.setProperty('--rbn-pill-opacity', '0');
    pillOpacityCached = 0;
    rbnPillHideGeomTimer = window.setTimeout(function () {
      rbnPillHideGeomTimer = null;
      if (!bar || !bar.isConnected) return;
      bar.style.setProperty('--rbn-pill-tx', '0px');
      bar.style.setProperty('--rbn-pill-ty', '0px');
      bar.style.setProperty('--rbn-pill-w', '0px');
      bar.style.setProperty('--rbn-pill-h', '0px');
    }, PILL_OP_MS);
  }

  function resetDesktopPillImmediate() {
    cancelRbnPillHideGeom();
    var bar = getDesktopBar();
    if (!bar) return;
    bar.style.setProperty('--rbn-pill-tx', '0px');
    bar.style.setProperty('--rbn-pill-ty', '0px');
    bar.style.setProperty('--rbn-pill-w', '0px');
    bar.style.setProperty('--rbn-pill-h', '0px');
    bar.style.setProperty('--rbn-pill-opacity', '0');
    pillOpacityCached = 0;
  }

  function setDesktopPillToLabel(labelEl) {
    var bar = getDesktopBar();
    if (!bar || !labelEl) {
      if (bar) resetDesktopPillGeometry();
      return;
    }

    var pillTarget = labelEl.closest('.rbn-desktop-nav__trigger');
    if (!pillTarget || !bar.contains(pillTarget)) {
      if (bar) resetDesktopPillGeometry();
      return;
    }

    cancelRbnPillHideGeom();
    var wasHidden = pillOpacityCached < 0.01;
    var rect = pillTarget.getBoundingClientRect();
    var barRect = bar.getBoundingClientRect();

    if (wasHidden) {
      bar.classList.add('rbn-desktop-pill--instant');
    }

    bar.style.setProperty('--rbn-pill-tx', rect.left - barRect.left + bar.scrollLeft + 'px');
    bar.style.setProperty('--rbn-pill-ty', rect.top - barRect.top + bar.scrollTop + 'px');
    bar.style.setProperty('--rbn-pill-w', rect.width + 'px');
    bar.style.setProperty('--rbn-pill-h', rect.height + 'px');
    bar.style.setProperty('--rbn-pill-opacity', '1');
    pillOpacityCached = 1;

    if (wasHidden) {
      void bar.offsetWidth;
      requestAnimationFrame(function () {
        bar.classList.remove('rbn-desktop-pill--instant');
      });
    }
  }

  function syncDesktopPill() {
    if (!isDesktopNav() || !desktopRoot) return;

    if (hoveredDesktopLabel && hoveredDesktopLabel.isConnected && desktopRoot.contains(hoveredDesktopLabel)) {
      setDesktopPillToLabel(hoveredDesktopLabel);
      return;
    }

    if (desktopOpenPanelId) {
      var trigger = desktopRoot.querySelector('[data-rbn-top-trigger][data-panel-id="' + desktopOpenPanelId + '"]');
      var label = trigger && trigger.querySelector('[data-rbn-top-label]');
      if (label) {
        setDesktopPillToLabel(label);
        return;
      }
    }

    var current = desktopRoot.querySelector('[data-rbn-top-trigger].rbn-desktop-nav__trigger--active [data-rbn-top-label]');
    if (current) {
      setDesktopPillToLabel(current);
      return;
    }

    resetDesktopPillGeometry();
  }

  function clearDesktopPanelDeepState(panel) {
    if (!panel) return;
    panel.querySelectorAll('.rbn-desktop-sub-item.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
    panel.querySelectorAll('.rbn-desktop-sub-sub-list.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
    panel.querySelectorAll('.rbn-desktop-content-panel.is-active').forEach(function (el) {
      el.classList.remove('is-active');
      el.setAttribute('aria-hidden', 'true');
    });
    panel.querySelectorAll('.rbn-desktop-sub-sub-link.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
  }

  function setDesktopSubState(panel, subKey) {
    panel.querySelectorAll('.rbn-desktop-sub-item[data-sub-key]').forEach(function (li) {
      li.classList.toggle('is-active', li.getAttribute('data-sub-key') === subKey);
    });
    panel.querySelectorAll('[data-rbn-sub-group]').forEach(function (ul) {
      ul.classList.toggle('is-active', ul.getAttribute('data-rbn-sub-group') === subKey);
    });
  }

  function setDesktopContentState(panel, contentKey) {
    panel.querySelectorAll('.rbn-desktop-content-panel[data-content-panel]').forEach(function (el) {
      var on = !!contentKey && el.getAttribute('data-content-panel') === contentKey;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    panel.querySelectorAll('[data-rbn-content-trigger]').forEach(function (a) {
      a.classList.toggle('is-active', !!contentKey && a.getAttribute('data-content-key') === contentKey);
    });
  }

  function applyDesktopPanelDefaults(panel) {
    if (!panel) return;
    var inner = panel.querySelector('.rbn-desktop-panel__inner[data-default-sub-key]');
    if (!inner) return;
    var subKey = inner.getAttribute('data-default-sub-key');
    var contentKey = inner.getAttribute('data-default-content-key');
    if (!subKey) return;
    setDesktopSubState(panel, subKey);
    setDesktopContentState(panel, contentKey);
  }

  function syncDesktopViewportClass(panel) {
    var viewport = desktopRoot && desktopRoot.querySelector('[data-rbn-desktop-viewport]');
    if (!viewport) return;
    viewport.style.removeProperty('height');
    if (!panel) {
      viewport.classList.remove('rbn-desktop-dropdown__viewport--tall', 'rbn-desktop-dropdown__viewport--short');
      return;
    }
    var isTopLevel = !!panel.querySelector('.rbn-desktop-panel__inner--top-level');
    viewport.classList.toggle('rbn-desktop-dropdown__viewport--short', isTopLevel);
    viewport.classList.toggle('rbn-desktop-dropdown__viewport--tall', !isTopLevel);
  }

  function syncDesktopDropdownGeometry() {
    if (!desktopRoot || !headerSectionEl) return;
    var dropdown = desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
    if (!dropdown) return;
    if (!isDesktopNav() || dropdown.dataset.state === 'closed') {
      dropdown.style.removeProperty('top');
      return;
    }
    dropdown.style.top = Math.round(headerSectionEl.getBoundingClientRect().bottom) + 'px';
  }

  function scheduleDesktopDropdownGeometry() {
    if (!desktopRoot || !headerSectionEl) return;
    var dropdown = desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
    if (!dropdown || dropdown.dataset.state === 'closed' || desktopDropdownGeomRaf) return;
    desktopDropdownGeomRaf = requestAnimationFrame(function () {
      desktopDropdownGeomRaf = 0;
      syncDesktopDropdownGeometry();
    });
  }

  function clearDesktopClipClasses(dropdown) {
    if (!dropdown) return;
    dropdown.classList.remove(
      'rbn-desktop-dropdown--clip-in',
      'rbn-desktop-dropdown--clip-in-expanded',
      'rbn-desktop-dropdown--clip-out',
      'rbn-desktop-dropdown--clip-swap'
    );
  }

  function finishDesktopDropdownHide() {
    if (!desktopRoot) return;
    var dropdown = desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
    if (!dropdown) return;
    dropdown.dataset.state = 'closed';
    dropdown.setAttribute('aria-hidden', 'true');
    dropdown.style.removeProperty('top');
    clearDesktopClipClasses(dropdown);
    desktopOpenPanelId = null;
    syncDesktopViewportClass(null);
    desktopRoot.querySelectorAll('.rbn-desktop-panel.is-active').forEach(function (panel) {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
      clearDesktopPanelDeepState(panel);
    });
    desktopRoot.querySelectorAll('[data-rbn-top-trigger][aria-expanded="true"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    syncDesktopPill();
  }

  function closeDesktopDropdown() {
    if (!desktopRoot) return;
    var dropdown = desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
    if (!dropdown || dropdown.dataset.state === 'closed' || dropdown.dataset.state === 'closing') return;
    if (desktopCloseVisTimer) {
      clearTimeout(desktopCloseVisTimer);
      desktopCloseVisTimer = null;
    }
    if (!mqlReduceMotion.matches) {
      dropdown.classList.remove('rbn-desktop-dropdown--clip-in', 'rbn-desktop-dropdown--clip-in-expanded');
      dropdown.classList.add('rbn-desktop-dropdown--clip-out');
    }
    dropdown.dataset.state = 'closing';
    syncDesktopViewportClass(null);
    desktopCloseVisTimer = window.setTimeout(function () {
      desktopCloseVisTimer = null;
      finishDesktopDropdownHide();
    }, VIS_HIDE_DELAY_MS);
    hoveredDesktopLabel = null;
    syncDesktopPill();
  }

  function openDesktopPanel(panelId) {
    if (!desktopRoot) return;
    var dropdown = desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
    var panel = desktopRoot.querySelector('.rbn-desktop-panel[data-panel-id="' + panelId + '"]');
    if (!dropdown || !panel) return;

    var wasAlreadyOpen = dropdown.dataset.state === 'open';
    if (desktopCloseVisTimer) {
      clearTimeout(desktopCloseVisTimer);
      desktopCloseVisTimer = null;
    }

    clearDesktopClipClasses(dropdown);
    if (wasAlreadyOpen) {
      dropdown.classList.add('rbn-desktop-dropdown--clip-swap');
    } else if (!mqlReduceMotion.matches) {
      dropdown.classList.add('rbn-desktop-dropdown--clip-in');
    }

    desktopOpenPanelId = panelId;
    dropdown.dataset.state = 'open';
    dropdown.setAttribute('aria-hidden', 'false');

    desktopRoot.querySelectorAll('.rbn-desktop-panel').forEach(function (candidate) {
      var on = candidate === panel;
      candidate.classList.toggle('is-active', on);
      candidate.setAttribute('aria-hidden', on ? 'false' : 'true');
    });

    clearDesktopPanelDeepState(panel);
    applyDesktopPanelDefaults(panel);

    desktopRoot.querySelectorAll('[data-rbn-top-trigger]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', trigger.getAttribute('data-panel-id') === panelId ? 'true' : 'false');
    });

    syncDesktopViewportClass(panel);
    syncDesktopDropdownGeometry();

    if (wasAlreadyOpen) {
      requestAnimationFrame(function () {
        dropdown.classList.remove('rbn-desktop-dropdown--clip-swap');
        syncDesktopDropdownGeometry();
      });
    } else if (!mqlReduceMotion.matches && dropdown.classList.contains('rbn-desktop-dropdown--clip-in')) {
      afterNextPaint(function () {
        dropdown.classList.add('rbn-desktop-dropdown--clip-in-expanded');
        syncDesktopDropdownGeometry();
      });
    } else {
      afterNextPaint(syncDesktopDropdownGeometry);
    }

    syncDesktopPill();
  }

  function initDesktopNav() {
    if (!desktopRoot) return;
    if (desktopRoot.dataset.rbnHeaderBound === 'true') return;
    desktopRoot.dataset.rbnHeaderBound = 'true';

    var triggerMode = (desktopRoot.getAttribute('data-trigger') || 'hover').toLowerCase();
    var hoverRoot = desktopRoot.querySelector('[data-rbn-desktop-hover-root]');
    var bar = getDesktopBar();

    if (bar) {
      desktopRoot.querySelectorAll('.rbn-desktop-nav__list .rbn-desktop-nav__item').forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          if (!isDesktopNav()) return;
          var label = item.querySelector('[data-rbn-top-label]');
          if (label) {
            hoveredDesktopLabel = label;
            setDesktopPillToLabel(label);
          }
        });
      });
      bar.addEventListener('mouseleave', function () {
        if (!isDesktopNav()) return;
        hoveredDesktopLabel = null;
        syncDesktopPill();
      });
    }

    function bindTop(trigger) {
      var panelId = trigger.getAttribute('data-panel-id');
      if (!panelId) return;

      if (triggerMode === 'click') {
        trigger.addEventListener('click', function (event) {
          if (!isDesktopNav()) return;
          if (trigger.tagName === 'A') return;
          event.preventDefault();
          var dropdown = desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
          if (desktopOpenPanelId === panelId && dropdown && dropdown.dataset.state === 'open') {
            closeDesktopDropdown();
          } else {
            openDesktopPanel(panelId);
          }
        });
      }

      if (triggerMode === 'hover') {
        trigger.addEventListener('mouseenter', function () {
          if (isDesktopNav()) openDesktopPanel(panelId);
        });
      }
    }

    desktopRoot.querySelectorAll('[data-rbn-top-trigger]').forEach(bindTop);

    desktopRoot.querySelectorAll('.rbn-desktop-nav__link').forEach(function (leafLink) {
      leafLink.addEventListener('mouseenter', function () {
        if (!isDesktopNav()) return;
        if (desktopHoverLeaveTimer) {
          clearTimeout(desktopHoverLeaveTimer);
          desktopHoverLeaveTimer = null;
        }
        var dropdown = desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
        if (dropdown && dropdown.dataset.state === 'open') {
          closeDesktopDropdown();
        } else {
          hoveredDesktopLabel = null;
          syncDesktopPill();
        }
      });
    });

    if (hoverRoot) {
      hoverRoot.addEventListener('mouseleave', function () {
        if (!isDesktopNav() || triggerMode !== 'hover') return;
        if (desktopHoverLeaveTimer) clearTimeout(desktopHoverLeaveTimer);
        desktopHoverLeaveTimer = window.setTimeout(function () {
          desktopHoverLeaveTimer = null;
          if (isDesktopNav()) closeDesktopDropdown();
        }, 160);
      });
      hoverRoot.addEventListener('mouseenter', function () {
        if (!desktopHoverLeaveTimer) return;
        clearTimeout(desktopHoverLeaveTimer);
        desktopHoverLeaveTimer = null;
      });
    }

    if (!desktopGlobalEventsBound) {
      desktopGlobalEventsBound = true;
      document.addEventListener(
        'click',
        function (event) {
          if (!isDesktopNav() || !desktopRoot) return;
          var dropdown = desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
          if (!dropdown || dropdown.dataset.state === 'closed') return;
          if (desktopRoot.contains(event.target)) return;
          closeDesktopDropdown();
        },
        true
      );

      window.addEventListener(
        'scroll',
        function () {
          if (isDesktopNav() && desktopRoot) {
            var dropdown = desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
            if (dropdown && dropdown.dataset.state === 'open') closeDesktopDropdown();
          }
          scheduleDesktopDropdownGeometry();
        },
        { passive: true }
      );
    }

    desktopRoot.addEventListener('click', function (event) {
      if (!isDesktopNav()) return;

      var subTrigger = event.target.closest('[data-rbn-sub-trigger]');
      if (subTrigger && desktopRoot.contains(subTrigger)) {
        if (subTrigger.tagName === 'A') event.preventDefault();
        var panel = subTrigger.closest('.rbn-desktop-panel');
        var subKey = subTrigger.getAttribute('data-sub-key');
        if (!panel || !panel.classList.contains('is-active') || !subKey) return;
        setDesktopSubState(panel, subKey);
        setDesktopContentState(panel, subTrigger.getAttribute('data-content-key'));
        return;
      }

      var contentTrigger = event.target.closest('[data-rbn-content-trigger]');
      if (contentTrigger && desktopRoot.contains(contentTrigger)) {
        event.preventDefault();
        var contentPanel = contentTrigger.closest('.rbn-desktop-panel');
        if (!contentPanel || !contentPanel.classList.contains('is-active')) return;
        var contentSubKey = contentTrigger.getAttribute('data-sub-key');
        if (contentSubKey) setDesktopSubState(contentPanel, contentSubKey);
        setDesktopContentState(contentPanel, contentTrigger.getAttribute('data-content-key'));
      }
    });

    requestAnimationFrame(function () {
      syncDesktopPill();
      syncDesktopDropdownGeometry();
    });
  }

  function resetSubsInDisclosure(detail) {
    if (!detail) return;
    detail.querySelectorAll('details.rbn-sub-disclosure[open]').forEach(function (subDetail) {
      subDetail.open = false;
    });
    detail.querySelectorAll('details.rbn-sub-sub-disclosure[open]').forEach(function (subSubDetail) {
      subSubDetail.open = false;
    });
  }

  function openMobileMegaProductsDefaults(detail) {
    if (!detail || !detail.hasAttribute('data-rbn-mega-products') || mqlDesktop1150.matches) return;
    afterNextPaint(function () {
      if (!detail.open) return;
      var tier2 = detail.querySelector('details.rbn-sub-disclosure[data-rbn-mega-tier2-default]');
      if (tier2) tier2.open = true;
    });
  }

  function clearMobileMegaTier3Timer() {
    if (!mobileMegaTier3Timer) return;
    clearTimeout(mobileMegaTier3Timer);
    mobileMegaTier3Timer = null;
  }

  function resetHeaderTransientState() {
    clearMobileMegaTier3Timer();
    cancelRbnPillHideGeom();

    if (desktopCloseVisTimer) {
      clearTimeout(desktopCloseVisTimer);
      desktopCloseVisTimer = null;
    }
    if (desktopHoverLeaveTimer) {
      clearTimeout(desktopHoverLeaveTimer);
      desktopHoverLeaveTimer = null;
    }
    if (desktopDropdownGeomRaf) {
      cancelAnimationFrame(desktopDropdownGeomRaf);
      desktopDropdownGeomRaf = 0;
    }
    if (headerResizeRaf) {
      cancelAnimationFrame(headerResizeRaf);
      headerResizeRaf = 0;
    }

    hoveredDesktopLabel = null;
    desktopOpenPanelId = null;
    pillOpacityCached = 0;

    document.documentElement.classList.remove('rbn-mobile-nav-open');
    document.body.classList.remove('rbn-mobile-nav-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function scheduleMobileTier3AutoOpen(tier3, tier2, productsDetail) {
    if (!tier3 || mqlDesktop1150.matches) return;
    clearMobileMegaTier3Timer();
    mobileMegaTier3Timer = window.setTimeout(function () {
      mobileMegaTier3Timer = null;
      if (mqlDesktop1150.matches || !tier3.isConnected) return;
      if (tier2 && !tier2.open) return;
      if (productsDetail && !productsDetail.open) return;
      tier3.open = true;
      afterNextPaint(function () {
        if (productsDetail && productsDetail.isConnected) {
          updatePromoLeafClips(productsDetail);
        } else if (nav) {
          updatePromoLeafClips(nav);
        }
      });
    }, MOBILE_TIER3_AUTO_OPEN_MS);
  }

  function resetPromoLeafClips(root) {
    if (!nav) return;
    (root || nav).querySelectorAll('.rbn-promo-leaf-wrap').forEach(function (wrap) {
      wrap.classList.remove('has-more', 'is-expanded');
      var button = wrap.querySelector('[data-rbn-promo-more]');
      if (button) button.hidden = true;
    });
  }

  function updatePromoLeafClips(root) {
    if (!nav || mqlDesktop1150.matches) return;
    (root || nav).querySelectorAll('.rbn-promo-leaf-wrap').forEach(function (wrap) {
      var scroll = wrap.querySelector('.rbn-promo-leaf-scroll');
      var button = wrap.querySelector('[data-rbn-promo-more]');
      if (!scroll || !button || wrap.classList.contains('is-expanded')) return;
      wrap.classList.remove('has-more');
      button.hidden = true;
      if (scroll.scrollHeight > PROMO_LEAF_MAX_PX) {
        wrap.classList.add('has-more');
        button.hidden = false;
      }
    });
  }

  function clearRbnNavMotionInlineStyles() {
    if (!nav) return;
    nav.querySelectorAll('.rbn-dropdown, .rbn-sub-dropdown, ul.dropdown-content').forEach(function (el) {
      el.style.removeProperty('opacity');
      el.style.removeProperty('clip-path');
      el.style.removeProperty('will-change');
      el.style.removeProperty('transform');
    });
    nav.querySelectorAll('details.rbn-nav-disclosure, details.rbn-sub-disclosure, details.rbn-sub-sub-disclosure, details.nav-dropdown').forEach(function (detail) {
      detail.style.removeProperty('height');
      detail.style.removeProperty('overflow');
      detail.style.removeProperty('will-change');
    });
    nav.querySelectorAll('.rbn-sub-list > li, .rbn-category-label, .rbn-promo-item').forEach(function (el) {
      el.style.removeProperty('opacity');
      el.style.removeProperty('transform');
    });
  }

  function scheduleHeaderResizeWork() {
    if (headerResizeRaf) return;
    headerResizeRaf = requestAnimationFrame(function () {
      headerResizeRaf = 0;
      setHeaderHeightVar();
      if (isDesktopNav() && nav && nav.classList.contains('is-open')) closeNav();

      if (isDesktopNav()) {
        hoveredDesktopLabel = null;
        var dropdown = desktopRoot && desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
        if (dropdown && dropdown.dataset.state !== 'closed') {
          syncDesktopDropdownGeometry();
          if (dropdown.dataset.state === 'open') {
            syncDesktopViewportClass(desktopRoot.querySelector('.rbn-desktop-panel.is-active'));
          }
        }
        syncDesktopPill();
        return;
      }

      resetDesktopPillImmediate();
      if (desktopRoot) {
        var desktopDropdown = desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
        if (desktopDropdown && desktopDropdown.dataset.state !== 'closed') finishDesktopDropdownHide();
      }
      if (nav) updatePromoLeafClips(nav);
    });
  }

  function openNav() {
    if (!nav) return;
    nav.classList.add('is-open');
    document.documentElement.classList.add('rbn-mobile-nav-open');
    document.body.classList.add('rbn-mobile-nav-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('[aria-controls="' + MOBILE_NAV_ID + '"]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'true');
    });
  }

  function closeNav() {
    if (!nav) return;
    nav.classList.remove('is-open');
    clearMobileMegaTier3Timer();
    document.documentElement.classList.remove('rbn-mobile-nav-open');
    document.body.classList.remove('rbn-mobile-nav-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.querySelectorAll('[aria-controls="' + MOBILE_NAV_ID + '"]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
    nav.querySelectorAll('details.rbn-nav-disclosure[open], details.rbn-sub-disclosure[open], details.rbn-sub-sub-disclosure[open]').forEach(function (detail) {
      detail.open = false;
    });

    clearRbnNavMotionInlineStyles();
    afterNextPaint(function () {
      if (!nav.classList.contains('is-open')) clearRbnNavMotionInlineStyles();
    });
    [450, 750].forEach(function (delay) {
      window.setTimeout(function () {
        if (!nav.classList.contains('is-open')) clearRbnNavMotionInlineStyles();
      }, delay);
    });
    resetPromoLeafClips(nav);
  }

  function initMobileNav() {
    if (!nav) return;
    if (nav.dataset.rbnHeaderBound === 'true') return;
    nav.dataset.rbnHeaderBound = 'true';

    nav.addEventListener(
      'toggle',
      function (event) {
        var detail = event.target;
        if (!detail || !detail.matches || !detail.matches('details') || !nav.contains(detail)) return;

        if (!mqlDesktop1150.matches) {
          if (detail.matches('details.rbn-sub-disclosure[data-rbn-mega-tier2-default]')) {
            var productsDetail = detail.closest('details.rbn-nav-disclosure[data-rbn-mega-products]');
            if (detail.open) {
              var tier3Auto = detail.querySelector('details.rbn-sub-sub-disclosure[data-rbn-mega-tier3-default]');
              if (tier3Auto) scheduleMobileTier3AutoOpen(tier3Auto, detail, productsDetail);
            } else {
              clearMobileMegaTier3Timer();
              var tier3Close = detail.querySelector('details.rbn-sub-sub-disclosure[data-rbn-mega-tier3-default]');
              if (tier3Close) tier3Close.open = false;
            }
          }
          if (detail.matches('details.rbn-sub-sub-disclosure[data-rbn-mega-tier3-default]')) {
            clearMobileMegaTier3Timer();
          }
        }

        if (detail.open) {
          afterNextPaint(function () {
            updatePromoLeafClips(detail);
          });
        } else {
          resetPromoLeafClips(detail);
        }
      },
      true
    );

    nav.addEventListener('click', function (event) {
      var moreButton = event.target.closest('[data-rbn-promo-more]');
      if (!moreButton || !nav.contains(moreButton)) return;
      var wrap = moreButton.closest('.rbn-promo-leaf-wrap');
      if (!wrap) return;
      wrap.classList.add('is-expanded');
      wrap.classList.remove('has-more');
      moreButton.hidden = true;
    });

    nav.querySelectorAll('details.rbn-nav-disclosure').forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        if (!detail.open) {
          resetSubsInDisclosure(detail);
        } else {
          openMobileMegaProductsDefaults(detail);
        }
      });
    });

    document.querySelectorAll('[aria-controls="' + MOBILE_NAV_ID + '"]').forEach(function (button) {
      button.addEventListener('click', function () {
        nav.classList.contains('is-open') ? closeNav() : openNav();
      });
    });

    nav.addEventListener('click', function (event) {
      var closeButton = event.target.closest('.rbn-nav-close');
      if (closeButton) {
        closeNav();
        return;
      }
      var backButton = event.target.closest('[data-rbn-back]');
      if (!backButton) return;
      var dropdown = backButton.closest('.rbn-dropdown');
      var detail = dropdown && dropdown.closest('details.rbn-nav-disclosure');
      if (detail) detail.open = false;
    });
  }

  function initGlobalEvents() {
    window.addEventListener('resize', scheduleHeaderResizeWork);
    mqlDesktop1150.addEventListener('change', scheduleHeaderResizeWork);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      if (isDesktopNav() && desktopRoot) {
        var dropdown = desktopRoot.querySelector('[data-rbn-desktop-dropdown]');
        if (dropdown && (dropdown.dataset.state === 'open' || dropdown.dataset.state === 'closing')) {
          closeDesktopDropdown();
          return;
        }
      }

      if (!nav) return;
      var openDetail = nav.querySelector('details.rbn-nav-disclosure[open]');
      if (openDetail) {
        resetSubsInDisclosure(openDetail);
        openDetail.open = false;
      } else if (nav.classList.contains('is-open')) {
        closeNav();
      }
    });
  }

  function initHeaderInteractions(scope) {
    refreshHeaderRoots(scope);
    setHeaderHeightVar();
    initDesktopNav();
    initMobileNav();
  }

  window.__robosenHeaderInit = initHeaderInteractions;

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (!event.target.querySelector('#' + MOBILE_NAV_ID + ', [data-rbn-desktop-nav]')) return;
    initHeaderInteractions(event.target);
    scheduleHeaderResizeWork();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (!event.target.querySelector('#' + MOBILE_NAV_ID + ', [data-rbn-desktop-nav]')) return;
    resetHeaderTransientState();
  });

  initHeaderInteractions(document);
  initGlobalEvents();
})();
